// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import AiBehaviorFeedbackController from "./ai_behavior_feedback_controller"
application.register("ai-behavior-feedback", AiBehaviorFeedbackController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatPanelController from "./chat_panel_controller"
application.register("chat-panel", ChatPanelController)

import ChatSidebarController from "./chat_sidebar_controller"
application.register("chat-sidebar", ChatSidebarController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import PlacesAutocompleteController from "./places_autocomplete_controller"
application.register("places-autocomplete", PlacesAutocompleteController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GoalEditController from "./goal_edit_controller"
application.register("goal-edit", GoalEditController)

import GoalsFormController from "./goals_form_controller"
application.register("goals-form", GoalsFormController)

import GoalsPanelController from "./goals_panel_controller"
application.register("goals-panel", GoalsPanelController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MemoryController from "./memory_controller"
application.register("memory", MemoryController)

import MessageActionsController from "./message_actions_controller"
application.register("message-actions", MessageActionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)


import VoiceStreamingController from "./voice_streaming_controller"
application.register("voice-streaming", VoiceStreamingController)

import LivekitStreamingController from "./livekit_streaming_controller"
application.register("livekit-streaming", LivekitStreamingController)

import LivekitVoiceController from "./livekit_voice_controller"
application.register("livekit-voice", LivekitVoiceController)

import NudgeSettingsController from "./nudge_settings_controller"
application.register("nudge-settings", NudgeSettingsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import SpecializationsController from "./specializations_controller"
application.register("specializations", SpecializationsController)

import ParsleyFormController from "./parsley_form_controller"
application.register("parsley-form", ParsleyFormController)

import KnowledgeStoreController from "./knowledge_store_controller"
application.register("knowledge-store", KnowledgeStoreController)

import InvitationFormController from "./invitation_form_controller"
application.register("invitation-form", InvitationFormController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import DeclineModalController from "./decline_modal_controller"
application.register("decline-modal", DeclineModalController)

import EmailSelectController from "./email_select_controller"
application.register("email-select", EmailSelectController)

import ClientDeclineModalController from "./client_decline_modal_controller"
application.register("client-decline-modal", ClientDeclineModalController)

import ClientDocumentsModalController from "./client_documents_modal_controller"
application.register("client-documents-modal", ClientDocumentsModalController)

import TranscriptsController from "./transcripts_controller"
application.register("transcripts", TranscriptsController)

import DocumentSelectionController from "./document_selection_controller"
application.register("document-selection", DocumentSelectionController)

import PsychologistClientsModalController from "./psychologist_clients_modal_controller"
application.register("psychologist-clients-modal", PsychologistClientsModalController)

import SummaryChatController from "./summary_chat_controller"
application.register("summary-chat", SummaryChatController)

import EscalationModalController from "./escalation_modal_controller"
application.register("escalation-modal", EscalationModalController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import LanguageSelectorController from "./language_selector_controller"
application.register("language-selector", LanguageSelectorController)

import RadioHighlightController from "./radio_highlight_controller"
application.register("radio-highlight", RadioHighlightController)

import AudioUploadController from "./audio_upload_controller"
application.register("audio-upload", AudioUploadController)

import InviteTranscriptsController from "./invite_transcripts_controller"
application.register("invite-transcripts", InviteTranscriptsController)

import TranscriptionEditorController from "./transcription_editor_controller"
application.register("transcription-editor", TranscriptionEditorController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)
